import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_FUNCTIONAL_APP,
  GET_AZURE_FUNCTIONAL_APP_SUCCESS,
  GET_AZURE_FUNCTIONAL_APP_ERROR,
} from "./constant";

import { getAzureFunctionalAppApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureFunctionalAppList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureFunctionalAppApi, params, provider);
    yield put({ type: GET_AZURE_FUNCTIONAL_APP_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_FUNCTIONAL_APP_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureFunctionalAppSaga() {
  yield takeLatest(GET_AZURE_FUNCTIONAL_APP, getAzureFunctionalAppList);
}
